var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tenant.subdomain === '#pfx')?_c('div',[_c('FrontPagePfx')],1):_c('div',[_c('FrontPageTenant')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43e8b3cc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FrontPage.vue
// module id = xMH4
// module chunks = 1